import { render, staticRenderFns } from "./WisdomSiteIndex.vue?vue&type=template&id=9e1100ec&scoped=true&"
import script from "./WisdomSiteIndex.vue?vue&type=script&lang=js&"
export * from "./WisdomSiteIndex.vue?vue&type=script&lang=js&"
import style0 from "./WisdomSiteIndex.vue?vue&type=style&index=0&id=9e1100ec&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e1100ec",
  null
  
)

export default component.exports